const typographyModalCloneEquipModel = {
  text: 'Clone'
};

export default typographyModalCloneEquipModel;
